module.exports = __webpack_public_path__ + "img/minipro.df30cc7a.png";